'use strict'

import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'

import common from 'assets/themes/vacances-campings/js/page/common/index'

import type { Calendar as SearchCalendarType } from '@ui/Search/Calendar/component'

export default function (): void {
  document.addEventListener('click', function (e) {
    const target = e.target as HTMLElement

    if (target.matches('.open-calendar')) {
      e.preventDefault()
      e.stopPropagation()

      const event = new CustomEvent('close-all-modals')
      document.body.dispatchEvent(event)

      if (target.getAttribute('data-target-anchor')) {
        document.getElementById('search-availability-form')?.setAttribute('action', target.getAttribute('data-target-anchor') as string)
      }

      if (common.isMobile() || common.isTablet()) {
        document.querySelector<HTMLElement>('#search-filters-recap-list .dca-recap__item')?.click()
      } else {
        document.getElementById('results')?.scrollIntoView({
          block: 'start',
          inline: 'nearest',
          behavior: 'smooth',
        })

        const calendar = ElementPropertiesManager.getProperty<SearchCalendarType>(
          document.getElementById('checkInDate') as HTMLInputElement,
          'calendar'
        )
        calendar?.open()
      }
    }
  })
}
